<div class="full-container">
    <!-- Drop Down Button -->
    <div 
        *ngIf="!showCustom"
        class="button-container" 
        [ngClass]="hasError? 'error-container' : ''"
        [class.disabled]="disabled"
    >
        <!-- Placeholder text on selected option -->
        <div class="top-placeholder" *ngIf="optionExists">
            {{ placeholder }}
        </div>
        <!-- Button for creating dropdown -->
        <button
            mat-button
            type="button"
            class="drop-button"
            (click)="toggleOptions()"
            (blur)="blurToggleOptions()"
            [disableRipple]="true"
            [disabled]="disabled"
            [class.chosen-option]="optionExists"
            [class.button-disabled]="disabled"
            [ngClass]="hasError? 'error-button' : ''"
        >
            {{ label }}
            <!-- Downward Purple Arrow -->
            <div class="select-arrow" [ngClass]="{ 'error-arrow' : hasError, 'face-up' : showOptions, 'disabled-arrow' : disabled }"></div>
        </button>
    </div>
    <!-- Drop Down Error Message -->
    <span class="error-message bottom-align" *ngIf="hasError && !showCustom">{{ customErrorMessage }}</span>

    <!-- Drop Down Custom Input Field -->
    <mat-form-field
        *ngIf="showCustom"
        [appearance]="appearance"
        [floatLabel]="floatLabel"
        [ngClass]="{ hasError: hasError }"
    >
        <mat-label [ngClass]="{ inputIsWrong: hasError }">{{ customPlaceholder }}</mat-label>
        <input
            #customInput
            matInput 
            autocomplete="off"
            (focus)="showCustomMeasurement()"
            (keyup)="checkInputText($event)"
            (blur)="checkInputText($event)"
            (blur)="hideCustomMeasurement()"
            [type]="inputType"
            [required]="required"
            [maxLength]="6"
            [placeholder]="'Enter'"
            [ngClass]="{ inputIsWrong: hasError }"
            [(ngModel)]="defaultValue"
        />
    </mat-form-field>
    <div *ngIf="showCustom && showMeasurement" class="custom-measurement">
        {{ customMeasurement }}
    </div>
    <div *ngIf="showCustom" class="custom-button">
        <button
            class="custom-btn"
            (click)="toggleOptions()"
            (blur)="blurToggleOptions()"
        >
            <!-- Downward Purple Arrow -->
            <div class="select-arrow" [ngClass]="{ 'error-arrow' : hasError, 'face-up' : showOptions }"></div>
        </button>
    </div>
    <!-- Drop Down Error Message -->
    <span class="error-message" *ngIf="hasError && showCustom">{{ customErrorMessage }}</span>

    <!-- Drop Down Options -->
    <ul class="drop-options" [class.scroll]="scroll == true" *ngIf="showOptions && options && options.length">
        <li 
            class="option"
            *ngFor="let option of options; let i = index"
            [class.active-option]="i == activeOptionIndex"
            (click)="selectDropOption(option)"
        >
            {{ option.Value }}
        </li>
    </ul>
</div>